/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var PlusIcon16Light = forwardRef('PlusIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.5 1.91a.5.5 0 0 1 .5.5V7h4.59a.5.5 0 0 1 0 1H8v4.59a.5.5 0 0 1-1 0V8H2.41a.5.5 0 1 1 0-1H7V2.41a.5.5 0 0 1 .5-.5Z" })));
});
